
<template>
    <div class="section">
        <div class="container">
            <div class="columns account-header is-auth">
                <div class="column main-column is-tablet-landscape-padded">
                    <div class="auth-title">
                        <img :src="require('../../assets/images/cropped-logotipo-bambi.png')" alt="logo" class="brand-filigrane">
                    </div>
                    <div class="main-auth-wrapper">
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AuthView',
}
</script>

<style>
    .auth-title .brand-filigrane {
        opacity: 1;
    }
</style>